<template>
  <v-container fluid>
    <v-alert v-if="!empresa_valida" type="info" outlined>
      Esta pantalla no está disponible para la empresa seleccionada.
    </v-alert>

    <v-data-table
      v-else
      :headers="headers"
      :items="items_permisos"
      :loading="loading"
      dense
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Configuración botones</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="id_usuario"
            :items="items_usuarios"
            item-text="nombre"
            item-value="id_usuario"
            label="Usuario"
            outlined
            dense
            hide-details
            @change="listarPermisos()"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!id_usuario"
            :loading="loading_guardar"
            @click="guardarPermisos()"
          >
            Guardar
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.pantalla`]="{ item }">
        {{ nombrePantalla(item.pantalla) }}
      </template>

      <template v-for="b in botones" v-slot:[`item.${b.value}`]="{ item }">
        <v-checkbox
          :key="b.value"
          v-model="item[b.value]"
          dense
          hide-details
          class="d-inline-block mt-0"
        ></v-checkbox>
      </template>

      <template v-slot:no-data>
        Seleccione un usuario
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" timeout="5000" top right outlined color="primary">
      <v-icon color="yellow">fa-solid fa-circle-info</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { EMPRESAS_PERMISOS_BOTONES } from "@/settings/permisoBotones";

export default {
  data: () => ({
    loading: false,
    loading_guardar: false,
    id_usuario: 0,
    items_usuarios: [],
    items_permisos: [],
    pantallas: [
      { value: "facturacion", text: "Facturación" },
      { value: "compras", text: "Compras" },
    ],
    botones: [
      { value: "nuevo", text: "Nuevo" },
      { value: "guardar", text: "Guardar" },
      { value: "actualizar", text: "Actualizar" },
      { value: "anular", text: "Anular" },
      { value: "eliminar", text: "Eliminar" },
      { value: "enviar_dte", text: "Enviar DTE" },
    ],
    snackbar: false,
    snackbar_text: "",
  }),
  computed: {
    id_empresa() {
      return this.$store.state.emp ? this.$store.state.emp.id_empresa : null;
    },
    empresa_valida() {
      return EMPRESAS_PERMISOS_BOTONES.includes(Number(this.id_empresa));
    },
    headers() {
      return [
        { text: "Pantalla", value: "pantalla", sortable: false },
        ...this.botones.map((b) => ({
          text: b.text,
          value: b.value,
          sortable: false,
          align: "center",
        })),
      ];
    },
  },
  watch: {
    // La empresa puede cargarse después de abrir la pantalla (F5)
    id_empresa: {
      immediate: true,
      handler() {
        this.id_usuario = 0;
        this.items_permisos = [];
        this.items_usuarios = [];
        if (this.empresa_valida) {
          this.listarUsuarios();
        }
      },
    },
  },
  methods: {
    listarUsuarios() {
      axios
        .get("api/UsuariosXEmpresas/ListarXEmpresa/" + this.id_empresa)
        .then((response) => {
          this.items_usuarios = response.data;
        });
    },
    nombrePantalla(pantalla) {
      const p = this.pantallas.find((x) => x.value == pantalla);
      return p ? p.text : pantalla;
    },
    listarPermisos() {
      if (!this.id_usuario) {
        this.items_permisos = [];
        return;
      }
      this.loading = true;
      axios
        .get("api/PermisosBotones/Listar/" + this.id_usuario + "/" + this.id_empresa)
        .then((response) => {
          const guardados = Array.isArray(response.data) ? response.data : [];
          // Una fila por pantalla; si no hay registro, todo inicia marcado
          this.items_permisos = this.pantallas.map((pant) => {
            const g = guardados.find((x) => x.pantalla == pant.value);
            const fila = { pantalla: pant.value };
            this.botones.forEach((b) => {
              fila[b.value] = g ? g[b.value] === true || g[b.value] === 1 : true;
            });
            return fila;
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.snackbar_text = "No se pudieron cargar los permisos.";
          this.snackbar = true;
        });
    },
    guardarPermisos() {
      if (!this.id_usuario) {
        this.snackbar_text = "Debe de seleccionar un usuario.";
        this.snackbar = true;
        return;
      }
      this.loading_guardar = true;
      axios
        .post("api/PermisosBotones/Guardar", {
          id_usuario: this.id_usuario,
          id_empresa: this.id_empresa,
          permisos: this.items_permisos,
        })
        .then(() => {
          this.loading_guardar = false;
          this.snackbar_text = "Permisos guardados.";
          this.snackbar = true;
          // Si se editó a sí mismo, refrescar sus botones
          if (this.id_usuario == this.$store.state.usuario.idUsuario) {
            this.$store.dispatch("cargarPermisosBotones");
          }
        })
        .catch(() => {
          this.loading_guardar = false;
          this.snackbar_text = "No se pudieron guardar los permisos.";
          this.snackbar = true;
        });
    },
  },
};
</script>